import {generateFullUrl} from "services/utils/utils";

export const RecommendationRequest = {
    fromServer: (item) => {
        const sender = item.sender;
        const target = item.target;

        return {
            id: item.id,
            created_at: item.created_at,
            sender: {
                id: sender.id,
                name: sender.name,
                avatar: generateFullUrl(sender.avatar)
            },
            target: {
                id: target.id,
                name: target.name,
                avatar: generateFullUrl(target.avatar)
            }
        }
    }
}